import { createFileRoute, stripSearchParams } from "@tanstack/react-router";
import { startLessonFlowSearchDefaults } from "#/modules/les.start-flow/filters";
import { LesPreparationDialog } from "#/modules/les.planning/components/les-preparation-dialog";
import {
  preparationBeforeLoad,
  preparationLayoutOptions,
} from "#/modules/les.planning/preparation-routes";

export const Route = createFileRoute(
  "/$locale/{-$schoolyear}/_authenticated/$school/lessons/week/les",
)({
  ...preparationLayoutOptions,
  search: { middlewares: [stripSearchParams(startLessonFlowSearchDefaults)] },
  beforeLoad: ({ search, params, location, context }) =>
    preparationBeforeLoad("lesweek", { search, params, location, context }),
  component: LesweekLesPreparation,
});

function LesweekLesPreparation() {
  const params = Route.useParams();
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <LesPreparationDialog
      base="lesweek"
      params={params}
      search={search}
      klassen={Route.useLoaderData().klassen}
      onClose={(day) =>
        void navigate({
          to: "/$locale/{-$schoolyear}/$school/lessons/week",
          params,
          search: { date: day.toString(), view: search.view },
          replace: true,
          resetScroll: false,
          viewTransition: true,
        })
      }
    />
  );
}
